import { render, staticRenderFns } from "./MarketInformationNotAvailable.vue?vue&type=template&id=69d5b3e7&scoped=true"
import script from "./MarketInformationNotAvailable.vue?vue&type=script&lang=ts"
export * from "./MarketInformationNotAvailable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d5b3e7",
  null
  
)

export default component.exports